module.exports = __webpack_public_path__ + "static/media/lizanav.photo-IG.02239154.PNG";